<template>
    <FullFillBox
        :pageID="1012"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <div class="product-upload-excel">
            <h3>{{ $t('product_upload') }}</h3>
            <hr>
            <a :href="simpleFilePath">{{ $t('product_upload_simple') }}</a>
            <p>
                {{ $t('product_upload_excel_error_explain') }}
                <span style="color: red;">{{ $t('product_upload_data_duplicate') }}</span>
                |
                <span style="background-color: red;color: yellow;">{{ $t('product_upload_missing_field') }}</span>
            </p>
            <p>{{ $t('product_upload_excel_col') }}</p>
            <div class="rap-image">
                <img alt="simple_image" :src="simpleImagePath">
            </div>
            <hr>
            <p>
                {{ $t('product_upload_select_file') }}
                <span>
                    <input type="file" @change="selectExcelFile($event)"
                           accept=".xls,.xlsx" id="inputExcel">
                </span>
                <button class="btn btn-primary" v-if="getInputExcel" @click="reviewExcel">
                    {{ $t('common_review') }}
                </button>
            </p>
            <hr>
            <p class="error-text" v-if="errorTitle">{{ errorTitle }}</p>
            <div class="rag-image" id="tableDiv">
                <h6 class="error-text">
                    <span style="color: black">{{ $t('product_upload_total_row') }} {{ excelTotalRow }} ;</span>
                    {{ excelDetails }}
                </h6>
                <p>
                    <button class="btn btn-warning" type="button"
                            data-bs-toggle="collapse" data-bs-target="#collapseExample"
                            aria-expanded="false" aria-controls="collapseExample">
                        {{ $t('error_expand_error_details') }}
                    </button>
                </p>
                <div class="collapse" id="collapseExample">
                    <div id="errorDetailList"></div>
                </div>
                <hr>
                <button class="btn btn-primary" type="button"
                        @click="confirmUpload" id="common_upload"
                        style="margin: auto"
                >
                    {{ $t('common_upload') }}
                </button>
                <hr>
                <div ref="tabulatorTableUse"></div>
            </div>
        </div>

    </FullFillBox>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "ProductExcelUploadView",
    components: {
        FullFillBox,
    },
    data() {
        return {
            permissionDetails: {},
            simpleImagePath: this.$store.state.serverIp + '/media/website/images/product_excel_simple.jpg',
            simpleFilePath: this.$store.state.serverIp + '/media/website/simples/product_excel_simple.xlsx',

            getInputExcel: '',
            excelDetails: '',
            errorTitle: '',
            errorDetails: '',
            excelTotalRow: '',
        }
    },
    methods: {
        selectExcelFile(e) {
            this.getInputExcel = e.target.files.item(0)
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        delTableItem(rowID){
            this.$swal.fire({
                title: this.$t('common_confirm_action_delete'),
                icon: "info"
            }).then((result) => {
                if(result.isConfirmed){
                    this.tabulator.setData(this.tabulator.getData().filter(a => a.row !== rowID))
                }
            })
        },
        resetAllDataError(){
            // Reset data
            this.excelDetails = ""
            this.errorTitle = ""
            document.getElementById('tableDiv').style.display = 'none'
            document.getElementById('common_upload').style.display = 'block'
        },
        async processOnReturnData(response){
            document.getElementById('tableDiv').style.display = 'block'

            let errorsRowList = response.data.errors.errors_row
            this.excelTotalRow = response.data.details.total_row
            this.excelDetails = this.$t('error_error_list')
            for(let e=0;e<errorsRowList.length;e++){
                if(e === errorsRowList.length-1){
                    this.excelDetails += errorsRowList[e]
                }else{
                    this.excelDetails += errorsRowList[e] + ", "
                }
            }

            this.tabulator.setData(response.data.details.data)

            let parent = document.getElementById('errorDetailList')
            let getErrorList = response.data.errors.errors_details
            for (let i = 0; i < getErrorList.length; i++) {
                let htmlContent = await this.$serverErrorReturn(getErrorList[i]['errors'])
                let subParent =
                    "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                    "<div class='col-3 my-auto'>" +
                    "<h4><strong>" + this.$t('common_row') + " " + getErrorList[i]['row'] + "</strong></h4>" +
                    "</div>" +
                    "<div class='col-9'>" + htmlContent + "</div>" +
                    "</div><br>"
                parent.innerHTML += subParent
            }
        },
        async reviewExcel() {
            this.$store.commit('setIsTopLoading', true)

            // Reset data
            this.resetAllDataError()

            let postData = {
                "excel": this.getInputExcel
            }
            // delete this.$mainApi.defaults.headers.common["content-type"]
            await this.$mainApi.post('api/product/import/', postData, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .then(async response => {
                    if (response.data.status === 80) {
                        await this.processOnReturnData(response)
                    } else {
                        this.errorTitle = response.data.errors
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async confirmUpload(){
            this.$store.commit('setIsTopLoading', true)

            // Reset data
            this.resetAllDataError()

            let postData = {
                "data": this.tabulator.getData()
            }
            await this.$mainApi.post('api/product/confirm/', postData)
                .then(async response => {
                    if (response.data.status === 80) {
                        let errorRowList = response.data.errors.errors_row
                        response.data.errors.errors_details = response.data.errors.errors_details.filter(a => errorRowList.includes(a.row))

                        await this.processOnReturnData(response)

                        // .map((a) => {a.is_error=true})
                        this.tabulator.setData(this.tabulator.getData().filter(a => errorRowList.includes(a.row)))

                        document.getElementById('common_upload').style.display = 'none'

                        if(errorRowList.length === 0){
                            this.$store.commit('setIsTopLoading', false)
                            this.$toast.success(this.$t('common_success'))
                            this.$router.push('/product')
                        }
                    } else {
                        this.errorTitle = response.data.errors
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('product_upload')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: 'row', field: 'row', sorter: 'number', resizable:false,
                    width:80, responsive:0, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'Server', field: 'is_duplicate_outCode_from_server',
                    resizable:false, formatter:"tickCross",
                    width:50, responsive:0, headerVertical:true
                },
                {title: 'Excel', field: 'is_duplicate_outCode_in_same_upload',
                    resizable:false, formatter:"tickCross",
                    width:50, responsive:0, headerVertical:true
                },
                {title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable:false,
                    responsive:0, width: 200,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'innerCode', field: 'innerCode', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_category'), field: 'category', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 1, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_brand'), field: 'brand', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'name_en', field: 'name_en', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'name_zh', field: 'name_zh', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'size', field: 'size', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'size_detail', field: 'size_detail', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'size_remarks', field: 'size_remarks', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_color'), field: 'color', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_material'), field: 'material', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_inner_packing'), field: 'in_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit1', field: 'in_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit2', field: 'in_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit1', field: 'out_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit2', field: 'out_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'min_stock', field: 'min_stock', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_length', field: 'in_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_width', field: 'in_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_height', field: 'in_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_length', field: 'out_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_width', field: 'out_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_height', field: 'out_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'net_weight', field: 'net_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'gross_weight', field: 'gross_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, headerVertical:true,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'flag', field: 'flag', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, formatter:"tickCross", headerVertical:true,
                },
                {formatter: () => {return "<i class='bi bi-trash-fill'></i>"},
                    headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                    headerMenu: this.getHeaderMenu,
                    headerSort:false, width:10, responsive:0,
                    cellClick: (e, row, formatterParams) => {
                        this.delTableItem(row.getData().row)
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            // layout: "fitColumns",
            movableColumns:true,
            movableRows: false,
            initialSort: [
                {column:"row", dir:"asc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().is_error === true){
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
        document.getElementById('tableDiv').style.display = 'none'
    }

}
</script>

<style scoped>
.product-upload-excel {

}

</style>
